import { apiFetch, apiFetchBlob } from './api.js';

/**
 * Generated documents (spec §13.8). A document is produced and kept on the
 * server, then opened through its report — which re-checks, on every open,
 * that you may see the record it was made from.
 */

export interface GeneratedDocument {
  id: string;
  title: string;
  byteSize: number | null;
  createdAt: string;
}

export const generateLessonPdf = (lessonId: string) =>
  apiFetch<{ document: GeneratedDocument }>(`/lesson-learned/lessons/${lessonId}/pdf`, { method: 'POST' });

export const issueAuditReport = (auditId: string, templateId?: string) =>
  apiFetch<{ document: GeneratedDocument }>(`/audit/audits/${auditId}/report/issue`, {
    method: 'POST',
    body: JSON.stringify(templateId ? { templateId } : {}),
  });

/** Fetch a kept document and hand it to the browser as a download. */
export async function downloadDocument(id: string, filename: string): Promise<void> {
  const blob = await apiFetchBlob(`/reports/generated/${id}/file`);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
